<template>
<div>
  <a @click="open" :class="btnClassComputed">
    <slot>
    </slot>
  </a>
  <transition name="slide">
  <div @click.self="close" class="modal-box-wrapper" v-if="isOpen">
    <div class="modal-box clean-this" v-if="isOpen">
      <div class="modal-box--content">
        <h3 v-if="title" class="modal-box--title">{{title}}</h3>
        <p class="">
          {{content}}
        </p>
      </div>
      <div class="modal-box--footer" v-if="footer">
        {{footer}}
      </div>
      <div class="modal-box--footer" v-else-if="actions">
        <button v-for="action in actions" :key="action.name" :data-action="action.action" @click="actionTrigger(action.name)" :class="action.class">
          {{$t('ui.global.' + action.name)}}
        </button>
      </div>
    </div>
  </div>
  </transition>
</div>
</template>
<script>
export default {
  props: ['content', 'title', 'btnClass', 'footer', 'actions'],
  methods: {
    close(){
      this.isOpen = false
    },
    open(){
      this.isOpen = true
    },
    actionTrigger(name){
      this.$emit('action', name)
      this.close()
    }
  },
  data (){
    return {
      isOpen: false
    }
  },
  computed: {
    btnClassComputed(){
      if(this.btnClass) {
        return this.btnClass
      }else{
        return "btn"
      }
    }
  }
}
</script>
<style lang="scss">

.clean-this {
  padding: 40px 40px 20px 40px;
  }

.modal-box-wrapper{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: opacity 0.15s ease-out;
  overflow: hidden;
  z-index: 10;
  &.slide-enter,
  &.slide-leave-to{
    opacity: 0;
  }
  .modal-box--footer {
    text-align: center;
    padding: 2em 1em 1em;
    border: 0;
  }
  .btn-cancel {
    margin-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?e6c6b78e